var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21.9032,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_84_1028",
    transform: "matrix(0.0104167 0 0 0.00856039 0 0.0891013)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_84_1028",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACyUlEQVR4nO3ZPWtVURCF4S1BLSSFWlmkEBSxTmGlhWAr/gBRay1MaeNHZZtGrUTBPxCstbG3VbDUSi0ELRTx45UDFwzq9c65mXNm9j7rgUBIYNhkCFkrU4qIiIiIiEgCwLnuI/odkwSsAm9mH6vR75kcYJPfNqPfMynAOvB92wK6z9ej3zUJwArwnL91X1uJfl/zgA3m24h+X9OANeDTfxbQfW8t+p3NArZYbCv6nS1nfit1g4Eyv5W6wYCZ30rdYKDMb6VuMGDmt3LtBsAV4GyZigWZ38qlGwBngG/Aa2BfaZ0h81vtuBsAx4AP22beLq0zZn6rpbsBcAB49ce8r8Dx0qqemX+wbgDsBp7OmfcM2FVas0TmH6wbAPcWzDxfWrNk5nfvBsBVw7y3wP7Sih1kftduABzp8Y67pQUOmd+1GwBPjPN+ACdK7Zwyv1s3mP0WfDHOq/sY5Jj5XbsBcN08ES6XWjlnfrduAOwBXhjnfQQOldoMlPndugFwEvhpnPeo1GTAzO/aDYD75olwutRi4Mzv1g1m/454Z5zX/dtib8luhMzv3Q0umCfCtZLZiJk/qht8Bg6XrEbO/J7d4GiPbvC4ZBSQ+b27wQ3zxIzXs6DMH9UNcl3PgjN/VDfIcT1LkPm9u8ED47wc17MkmT+qG8RezxJlfu9ucNE8Mep6ljDze3eDeTfjHNezpJk/qhvcGeennj/ze3eDmymvZ8kzv3c3eJnqelZJ5vfsBqd6dINhr2cVZX7vbvAwxfWssszv2Q0OAu9Dr2cVZn7vbnAp7HpWcebH6w9o13h7dAPf61nlmT+qG/hczxrI/N7d4Nao17NGMn9UN8h5PRMRERERkdzMFUb+SQsIpgUE0wKCaQHBtIBgWkAwLSBYZIUQEREREZFKRReZ2mkBwbSAYFpAMC0gmBYQTAsIpgUEi6wQIiIiIiJSUvoFfQ86sWD/1B4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthlogo);
export default __webpack_public_path__ + "static/media/earthlogo.fe425f53bc99e644d385ec67ca35c598.svg";
export { ForwardRef as ReactComponent };